module.exports = __webpack_public_path__ + "img/logo.59a51c3b.svg";